import { useState } from 'react'
import Table, { TableRow } from '../../../../common/components/molecule/Table/Table'
import ConfirmationModal from '../../../../common/components/atom/ConfirmationModal/ConfirmationModal'
import RowActions from '../../../../common/components/atom/RowActions'
import { Momi } from '../../../../features/momi/types/momiTypes'
import { ResponseAPIWithPagination } from '../../../../common/types/API.types'
import { useMomis, useDeleteMomi } from '../../../../features/momi/hooks/useMomis'
import { useToast } from '../../../../common/providers/ToastProvider/useToast'
import RenameMomiDialog from '../RenameMomiDialog/RenameMomiDialog'

export default function MomiList() {
  const { data, isLoading, isError } = useMomis()
  const deleteMomi = useDeleteMomi()
  const toast = useToast()

  const [renameTarget, setRenameTarget] = useState<Momi | null>(null)
  const [deleteTarget, setDeleteTarget] = useState<Momi | null>(null)

  const momis: Momi[] =
    (data as ResponseAPIWithPagination<Momi> | undefined)?.data ?? []

  const handleDeleteConfirm = () => {
    if (!deleteTarget) return
    deleteMomi.mutate({
      momiId: deleteTarget.momi_id,
      callbackFunc: ({ error }) => {
        if (error) {
          toast.error(
            error?.response?.data?.message ?? 'Erreur lors de la suppression'
          )
        } else {
          toast.success('MoMi supprimé')
        }
        setDeleteTarget(null)
      },
    })
  }

  const bodyData: TableRow[] = momis.map((momi) => ({
    id: momi.momi_id,
    data: [
      momi.momi_name,
      momi.momi_uuid.slice(0, 8) + '\u2026',
      momi.momi_status || '\u2014',
      <RowActions
        key={`actions-${momi.momi_id}`}
        onEdit={() => setRenameTarget(momi)}
        onDelete={() => setDeleteTarget(momi)}
      />,
    ],
  }))

  const emptyMessage = isError
    ? 'Impossible de charger les MoMis'
    : 'Aucun MoMi enregistré'

  return (
    <>
      <Table
        headerTitle={['Nom', 'UUID', 'Statut', '']}
        bodyData={isError ? [] : bodyData}
        isLoading={isLoading}
        emptyMessage={emptyMessage}
      />

      <RenameMomiDialog
        open={!!renameTarget}
        momi={renameTarget}
        onClose={() => setRenameTarget(null)}
      />

      <ConfirmationModal
        isOpen={!!deleteTarget}
        type="danger"
        title="Supprimer ce MoMi ?"
        message={deleteTarget ? `Supprimer « ${deleteTarget.momi_name} » ?` : ''}
        confirmText="Supprimer"
        cancelText="Annuler"
        onConfirm={handleDeleteConfirm}
        onCancel={() => setDeleteTarget(null)}
      />
    </>
  )
}
